document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".vb--slider-container").forEach((slideshow: HTMLElement) => {
		let interval = window.setInterval(function () {
			let previous = slideshow.querySelector(".vb--previous");
			let current = slideshow.querySelector(".vb--current");
			let next = slideshow.querySelector(".vb--next");
			previous.classList.remove("vb--previous");
			current.classList.add("vb--previous");
			current.classList.remove("vb--current");
			next.classList.add("vb--current");
			next.classList.remove("vb--next");
			(next.nextElementSibling ? next.nextElementSibling : slideshow.firstElementChild).classList.add("vb--next");
		}, 7000);
	});
});
